module.exports = __webpack_public_path__ + "static/media/predictive-chart.ebc126f1.png";